import React, { useContext, useEffect, useState } from 'react'

import { auth, db, storage, functions} from "../firebase_setup"
import { Timestamp, collection, onSnapshot } from '@firebase/firestore';  // Corrected import
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore'; // Make sure Firestore is imported
import { inappropriateWords } from '../constant/profanity'; // Adjust the path based on your folder structure
import axios from 'axios'; // For making HTTP requests

const DBContext = React.createContext()

export function useAuth() {
    return useContext(DBContext)
}

export function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState();
    const [loading, setLoading] = useState(true)
    const [userInfo, setUserInfo] = useState(null);

    function login(email, password) {
        return auth.signInWithEmailAndPassword(email, password)
    }

    function sendEmailVerification() {
        const user = auth.currentUser;
      
        if (user) {
          user
            .sendEmailVerification()
            .then(() => {
              // Email verification sent successfully
              // console.log("Email verification sent");
            });
        }
      }
      
      // Helper function to calculate age group based on date of birth
      function calculateAgeGroup(dateOfBirth) {
        const today = new Date();
        const birthDate = new Date(dateOfBirth);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }

        // Determine age group
        if (age >= 1 && age <= 5) {
          return "Early years (1-5)";
        } else if (age >= 6 && age <= 13) {
          return "Primary (6-13)";
        } else if (age >= 14 && age <= 18) {
          return "Preparing For Adulthood (14-18)";
        } else if (age >= 18 && age <= 25) {
          return "Young Adults (18-25)";
        }
        return "Adult (25+)"; // For ages outside these ranges
      }

      async function signUp(formData) {
        let user = null;
        try {
          // Step 1: Create user with email and password
          const userCredential = await auth.createUserWithEmailAndPassword(formData.email, formData.password);
          user = userCredential.user;
      
          // Step 2: Set display name
          const displayName = `${formData.firstName} ${formData.lastName}`;
          await user.updateProfile({ displayName });
      
          // Step 3: Get latitude and longitude from postcode
          const { latitude, longitude } = await geocodeAddress(formData.postcode);
      
          // Step 4: Prepare base user data
          const userData = {
            name: displayName,
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: formData.email,
            address: formData.address,
            postcode: formData.postcode,
            localAuthorityId: formData.localAuthorityId || null,
            accountType: formData.accountType,
            role: "family",
            createdAt: Timestamp.now(),
            latitude: latitude.toString(),
            longitude: longitude.toString(),
            favoriteServices: [],
            favoriteProducts: []
          };
      
          // Step 5: Add profile data based on account type
          if (formData.accountType === 'self') {
            userData.profile = {
              ...formData.profile,
              dateOfBirth: formData.profile.dateOfBirth || null,
              interests: formData.profile.interests || [],
              age: calculateAgeGroup(formData.profile.dateOfBirth) // Add age group
            };
          } else if (formData.accountType === 'children') {
            userData.children = formData.children.map((child, index) => ({
              id: `${user.uid}_child_${Date.now()}_${Math.random().toString(36).substring(2, 10)}`, // Create unique ID for each child with random string
              ...child,
              dateOfBirth: child.dateOfBirth || null,
              interests: child.interests || [],
              age: calculateAgeGroup(child.dateOfBirth) // Add age group for each child
            }));
          }
      
          // Step 6: Save to Firestore
          await db.collection('users').doc(user.uid).set(userData);
      
          // Step 7: Send email verification
          await user.sendEmailVerification();
          // console.log("Signup successful and email verification sent");
      
          return user;
        } catch (error) {
          // console.error("Signup failed:", error);
          // Clean up: Delete user if created but subsequent steps failed
          if (user) {
            try {
              await user.delete();
              // console.log("User deleted due to signup error");
            } catch (deleteError) {
              // console.error("Error deleting user:", deleteError);
            }
          }
          throw error;
        }
      }
      
      async function signUpBusiness(
        businessName,
        email,
        password,
        address,
        postcode,
        organizationType,
        registrationNumber,
        vatNumber, // Added VAT number here
        role,
        bankAccountNumber,
        sortCode,
        documentFiles,
        localAuthorityId
      ) {
        let user = null;
        try {
          const userCredential = await auth.createUserWithEmailAndPassword(email, password);
          user = userCredential.user;
      
          // Update user profile
          await user.updateProfile({ displayName: businessName });
      
          // Combine address and postcode for geocoding
          const fullAddress = `${address}, ${postcode}`;
          const { latitude, longitude } = await geocodeAddress(fullAddress);
      
          // Upload documents and get URLs
          const documentUrls = await uploadBusinessDocuments(documentFiles);
      
         // Save business data to Firestore
  await db.collection('users').doc(user.uid).set({
    name: businessName,
    email,
    address,
    postcode,
    organizationType,
    registrationNumber,
    vatNumber, // Store VAT number
    businessRole: role,
    bankAccountNumber,
    sortCode,
    documents: documentUrls,
    localAuthorityId,
    role: "business",
    createdAt: Timestamp.now(),
    approved: false,
    denied: false,
    latitude: latitude.toString(),
    longitude: longitude.toString(),
    favoriteServices: [],
    favoriteProducts: [],
  });

      
          // Send email verification
          await user.sendEmailVerification();
      
          // console.log("Business signup successful and email verification sent");
          return user;
        } catch (error) {
          // console.error("Business Signup failed:", error);  
          // If user was created, delete the user
          if (user) {
            try {
              await user.delete();
              // console.log("User deleted due to signup error");
            } catch (deleteError) {
              // console.error("Error deleting user:", deleteError);
            }
          }
          throw error;
        }
      }
      

async function uploadBusinessDocuments(files) {
  const urls = await Promise.all(files.map(async file => {
    const storageRef = storage.ref();
    const fileRef = storageRef.child(`business_documents/${file.name}_${Date.now()}`);
    const uploadTaskSnapshot = await fileRef.put(file);
    return uploadTaskSnapshot.ref.getDownloadURL();
  }));
  return urls;
}

      

async function signupLa(
  firstName,
  lastName,
  email,
  password,
  address,
  postcode,
  department
) {
  let user = null;
  try {
    const userCredential = await auth.createUserWithEmailAndPassword(email, password);
    user = userCredential.user;

    // Formulate displayName from firstName and lastName
    const displayName = `${firstName} ${lastName}`;
    await user.updateProfile({ displayName });

    // Get latitude and longitude from postcode
    const { latitude, longitude } = await geocodeAddress(postcode);

    // Save authority data to Firestore
    await db.collection('users').doc(user.uid).set({
      name: firstName + " " + lastName,
      firstName,
      lastName,
      email,
      address,
      postcode,
      department,
      role: "local-authority",
      createdAt: Timestamp.now(),
      approved: false,
      denied: false,
      latitude: latitude.toString(),
      longitude: longitude.toString(),
      favoriteServices: [],
      favoriteProducts: [],
    });

    // Send email verification
    await user.sendEmailVerification();

    // console.log("LA signup successful and email verification sent");
    return user;
  } catch (error) {
    // console.error("LA Signup failed:", error);
    // If user was created, delete the user
    if (user) {
      try {
        await user.delete();
        // console.log("User deleted due to signup error");
      } catch (deleteError) {
        // console.error("Error deleting user:", deleteError);
      }
    }
    throw error;
  }
}

      
      
      function forgotPassword(email) {
        return auth
          .sendPasswordResetEmail(email)
          .then(() => {
            // Password reset email sent successfully
            // console.log("Password reset email sent");
          });
      }

      function getUserInfo(uid) {
        return db
          .collection('users')
          .doc(uid)
          .get()
          .then((doc) => {
            if (doc.exists) {
              // console.log('Fetching Users collection');
              return { id: doc.id, ...doc.data() }; // Include the document ID
            } else {
              // console.log('User document not found');
              return null;
            }          
          })
          .catch((error) => {
            // console.log('Error getting user document:', error);
            return null;
          });

      };
      

    function logout() {
        return auth.signOut()
    }


  
    async function sendMessage(senderId, recipientName, recipientId, messageText) {
      // console.log('Starting sendMessage with:', { senderId, recipientName, recipientId });
      // console.log('Message text:', messageText);
      
      const censoredMessage = censorMessage(messageText, inappropriateWords);
      // console.log('Message after censoring:', censoredMessage);
      
      try {
        // console.log('Ensuring conversation exists...');
        await ensureConversationExists(senderId, recipientId, recipientName);
        // console.log('Conversation ensured successfully');

        const messageData = {
          senderId: senderId,
          recipientId: recipientId,
          message: censoredMessage,
          timestamp: Timestamp.now(),
        };
        // console.log('Created message data:', messageData);

        try {
          const docRef = await db.collection('messages').add(messageData);
          // console.log('Message added successfully with ID:', docRef.id);

          // console.log('Updating last message timestamp...');
          await updateLastMessageTimestamp(senderId, recipientId, messageData.timestamp);
          // console.log('Last message timestamp updated successfully');
        } catch (error) {
          // console.error('Error in message creation or timestamp update:', error);
          throw error;
        }
      } catch (error) {
        // console.error('Error in conversation creation or message sending:', error);
        throw error;
      }
    }
    
   // Helper function to escape special characters for use in regular expressions
function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escapes special characters
}

// Helper function to check and flag inappropriate messages
function censorMessage(text, inappropriateWords) {
  const escapedWords = inappropriateWords.map(escapeRegExp); // Escape special characters in each word
  const regex = new RegExp(escapedWords.join('|'), 'gi');
  
  if (regex.test(text)) {
    // If inappropriate word is found, replace the entire message with a flag message
    return 'You sent an inappropriate message and have been flagged.';
  }
  
  // Otherwise, return the original message
  return text;
}

    
    
  
  function fetchMessages(userId, otherUserId) {
    if (!userId || !otherUserId) {
        // console.error("Invalid IDs provided", { userId, otherUserId });
        return () => {}; // Return an empty function for the unsubscribe call if IDs are invalid
    }

    const messagesRef = db.collection('messages');
    return (callback) => {
        const unsubscribe = messagesRef
            .where('senderId', 'in', [userId, otherUserId])
            .where('recipientId', 'in', [userId, otherUserId])
            .orderBy('timestamp', 'asc')
            .onSnapshot(snapshot => {
                const messages = [];
                snapshot.forEach(doc => {
                    if ((doc.data().senderId === userId && doc.data().recipientId === otherUserId) ||
                        (doc.data().senderId === otherUserId && doc.data().recipientId === userId)) {
                        messages.push({ id: doc.id, ...doc.data() });
                    }
                });
                callback(messages);
            }, error => {
                // console.error("Error fetching messages: ", error);
            });
        return unsubscribe;
    };
}

async function updateLastMessageTimestamp(senderId, recipientId, timestamp) {
  const conversationId = [senderId, recipientId].sort().join('_');
  const senderConvoRef = db.collection('users').doc(senderId).collection('conversations').doc(conversationId);
  const recipientConvoRef = db.collection('users').doc(recipientId).collection('conversations').doc(conversationId);

  await db.runTransaction(async (transaction) => {
    transaction.update(senderConvoRef, { lastMessageTimestamp: timestamp });
    transaction.update(recipientConvoRef, { lastMessageTimestamp: timestamp });
  });
  // console.log(`Updated last message timestamp for conversation ${conversationId}`);
}


async function ensureConversationExists(senderId, recipientId, recipientName) {
  // console.log('Starting ensureConversationExists with:', { senderId, recipientId, recipientName });
  
  const conversationId = [senderId, recipientId].sort().join('_');
  // console.log('Generated conversationId:', conversationId);
  
  const senderConvoRef = db.collection('users').doc(senderId).collection('conversations').doc(conversationId);
  const recipientConvoRef = db.collection('users').doc(recipientId).collection('conversations').doc(conversationId);
  
  // console.log('Created conversation refs for:', {
  //   senderPath: `users/${senderId}/conversations/${conversationId}`,
  //   recipientPath: `users/${recipientId}/conversations/${conversationId}`
  // });

  try {
    // Fetch both sender and recipient information
    // console.log('Fetching sender and recipient info...');
    const [senderDoc, recipientDoc] = await Promise.all([
      db.collection('users').doc(senderId).get(),
      db.collection('users').doc(recipientId).get()
    ]);

    if (!senderDoc.exists || !recipientDoc.exists) {
      throw new Error('Sender or recipient document does not exist');
    }

    const senderData = senderDoc.data();
    const recipientData = recipientDoc.data();
    const senderName = senderData?.name || "Unknown Sender";
    const actualRecipientName = recipientData?.name || "Unknown Recipient";

    // console.log('Retrieved names:', { senderName, actualRecipientName });

    // console.log('Starting Firestore transaction...');
    await db.runTransaction(async (transaction) => {
      // console.log('Inside transaction - fetching conversation docs...');
      const senderConvoDoc = await transaction.get(senderConvoRef);
      const recipientConvoDoc = await transaction.get(recipientConvoRef);
      
      // console.log('Conversation docs status:', {
      //   senderConvoExists: senderConvoDoc.exists,
      //   recipientConvoExists: recipientConvoDoc.exists
      // });

      if (!senderConvoDoc.exists || !recipientConvoDoc.exists) {
        // console.log('Creating conversation data object...');
        const timestamp = Timestamp.now();
        const convoData = {
          participantIds: [senderId, recipientId],
          participantNames: [senderName, actualRecipientName],
          lastMessage: "",
          lastMessageTimestamp: timestamp,
          unreadMessages: 0
        };
        // console.log('Conversation data:', convoData);

        if (!senderConvoDoc.exists) {
          // console.log('Setting sender conversation document...');
          transaction.set(senderConvoRef, convoData);
        }
        if (!recipientConvoDoc.exists) {
          // console.log('Setting recipient conversation document...');
          transaction.set(recipientConvoRef, convoData);
        }
      }
      // console.log('Transaction operations queued successfully');
    });
    // console.log('Transaction completed successfully');
    
  } catch (error) {
    // console.error('Transaction failed with error:', error);
    // console.error('Error details:', {
    //   code: error.code,
    //   message: error.message,
    //   stack: error.stack
    // });
    throw error;
  }
}
const fetchConversations = async (userId) => {
  const conversationsRef = db.collection("users").doc(userId).collection("conversations");
  try {
    const snapshot = await conversationsRef.orderBy("lastMessageTimestamp", "desc").get();
    const conversations = snapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: doc.id,
        participantNames: data.participantNames,
        participantIds: data.participantIds,
        lastMessage: data.lastMessage,
        lastActive: new Date(data.lastMessageTimestamp.seconds * 1000),
        unreadMessages: data.unreadMessages
      };
    });
    return conversations;
  } catch (error) {
    // console.error("Error fetching conversations: ", error);
    return [];
  }
};

async function fetchServices() {
  try {
      const snapshot = await db.collection('services').get();
      const services = snapshot.docs.map(doc => {
          return {
              id: doc.id,  // Include the document ID
              ...doc.data() // Spread the rest of the data
          };
      });
      return services;
  } catch (error) {
      // console.error("Error fetching services: ", error);
      return [];
  }
}

async function fetchServiceById(serviceId) {
  // console.log("Fetching service with ID:", serviceId); // Log the service ID to verify it's correct

  try {
    const docRef = db.collection('services').doc(serviceId);
    const doc = await docRef.get();
    if (doc.exists) {
      return { id: doc.id, ...doc.data() };
    } else {
      // console.log("No such service!");
      return null; // Handle the case where the service does not exist
    }
  } catch (error) {
      // console.error("Error fetching service: ", error);
    return null;
  }
}

async function createBlog(blogData) {
  try {
    const blogRef = await db.collection('blogs').add({
      ...blogData,
      created_at: Timestamp.now(),
      updated_at: Timestamp.now(),
    });
    // console.log('Blog created with ID: ', blogRef.id);
    return blogRef.id;
  } catch (error) {
    // console.error('Error creating blog:', error);
    throw error;
  }
}

async function updateBlog(blogId, blogData) {
  try {
    await db.collection('blogs').doc(blogId).update({
      ...blogData,
      updated_at: Timestamp.now(),
    });
    // console.log('Blog updated with ID: ', blogId);
    return blogId;
  } catch (error) {
    // console.error('Error updating blog:', error);
    throw error;
  }
}
async function uploadImage(file) {
  const storageRef = storage.ref();  // Ensure storage is correctly imported from Firebase setup
  const fileRef = storageRef.child(`blog_images/${file.name}_${Date.now()}`);  // Add a timestamp for uniqueness

  try {
    const uploadTaskSnapshot = await fileRef.put(file);
    const fileUrl = await uploadTaskSnapshot.ref.getDownloadURL();  // Get the download URL after upload
    // console.log('File available at:', fileUrl);
    return fileUrl;  // Return the file URL to be saved in Firestore
  } catch (error) {
    // console.error('Error uploading image:', error);
    throw error;
  }
}


async function fetchBlogs() {
  try {
      const snapshot = await db.collection('blogs')
          .orderBy('created_at', 'desc') // Order by 'created_at' field in descending order
          .get();
      const blogs = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
      }));
      return blogs;
  } catch (error) {
      // console.error("Error fetching blogs:", error);
      return [];
  }
}

async function fetchBlogById(id) {
  try {
    const blogRef = db.collection('blogs').doc(id);
    const blogDoc = await blogRef.get();
    if (blogDoc.exists) {
      return { id: blogDoc.id, ...blogDoc.data() };
    } else {
      // console.log("No such blog..");
      return null;
    }
  } catch (error) {
    // console.error("Error fetching blog by ID:", error);
    return null;
  }
}async function fetchCommentsForBlog(blogId, callback) {
  try {
    const blogRef = db.collection('blogs').doc(blogId);

    // Set up real-time listener using onSnapshot
    const unsubscribe = blogRef.onSnapshot((doc) => {
      if (doc.exists) {
        const blogData = doc.data();
        callback(blogData.comments || []); // Send comments to the callback
      } else {
        // console.error("No such blog for comments");
        callback([]); // Return an empty array if no blog found
      }
    }, (error) => {
      // console.error("Error fetching comments:", error);
      callback([]); // Handle any errors
    });

    // Return the unsubscribe function to stop the listener when needed
    return unsubscribe;
  } catch (error) {
    // console.error("Error setting up real-time listener:", error);
    return () => {}; // Return a dummy unsubscribe function on error
  }
}

async function addCommentToBlog(blogId, comment) {
  try {
    const blogRef = db.collection('blogs').doc(blogId);
    await blogRef.update({
      comments: firebase.firestore.FieldValue.arrayUnion(comment), // Add comment to array
    });
    // console.log("Comment added!");
  } catch (error) {
    // console.error("Error adding comment:", error);
    throw error;
  }
}

async function uploadProductImage(file) {
  const storageRef = storage.ref(); // Ensure storage is correctly imported from Firebase setup
  const fileRef = storageRef.child(`product_images/${file.name}_${Date.now()}`); // Add a timestamp for uniqueness

  try {
    const uploadTaskSnapshot = await fileRef.put(file); // Upload the file to Firebase Storage
    const fileUrl = await uploadTaskSnapshot.ref.getDownloadURL(); // Get the download URL after upload
    // console.log('Product image available at:', fileUrl);
    return fileUrl; // Return the file URL to be saved in Firestore
  } catch (error) {
    // console.error('Error uploading product image:', error);
    throw error;
  }
}
// Function to create a product in the 'admin-products' collection
async function createProduct(productData) {
  try {
    const productRef = await db.collection('admin-products').add({
      ...productData,
      created_at: Timestamp.now(),
      updated_at: Timestamp.now(),
    });

    // Handle image upload if productData contains image file
    if (productData.image) {
      const imageUrl = await uploadProductImage(productData.image, productRef.id);
      await productRef.update({ imageUrl });
    }

    // console.log('Product created with ID: ', productRef.id);
    return productRef.id;
  } catch (error) {
    // console.error('Error creating product:', error);
    throw error;
  }
}

// Function to upload product image to Firebase Storage
async function uploadProductImage(file, productId) {
  const storageRef = storage.ref();
  const fileRef = storageRef.child(`product_images/${productId}_${file.name}`);
  
  try {
    const uploadTaskSnapshot = await fileRef.put(file);
    const imageUrl = await uploadTaskSnapshot.ref.getDownloadURL();
    // console.log('Product image available at:', imageUrl);
    return imageUrl;
  } catch (error) {
    // console.error('Error uploading product image:', error);
    throw error;
  }
}

// Function to fetch products from the 'admin-products' collection
async function fetchProducts() {
  try {
    const snapshot = await db.collection('admin-products')
      .orderBy('created_at', 'desc')  // Sort by creation time
      .get();
    const products = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));
    return products;
  } catch (error) {
    // console.error('Error fetching products:', error);
    return [];
  }
}

// Function to update a product in the 'admin-products' collection
async function updateProduct(productId, productData) {
  try {
    await db.collection('admin-products').doc(productId).update({
      ...productData,
      updated_at: Timestamp.now(),
    });
    // console.log('Product updated with ID:', productId);
    return productId;
  } catch (error) {
    // console.error('Error updating product:', error);
    throw error;
  }
}

// Function to delete a product from the 'admin-products' collection
async function deleteProduct(productId) {
  try {
    await db.collection('admin-products').doc(productId).delete();
    // console.log('Product deleted with ID:', productId);
  } catch (error) {
    // console.error('Error deleting product:', error);
    throw error;
  }
}

// Function to create a widget in the 'admin-widgets' collection
async function createWidget(widgetData) {
  try {
    const widgetRef = await db.collection('admin-widgets').add({
      ...widgetData,
      created_at: Timestamp.now(),
      updated_at: Timestamp.now(),
    });

    if (widgetData.image) {
      const imageUrl = await uploadWidgetImage(widgetData.image, widgetRef.id);
      await widgetRef.update({ imageUrl });
    }

    // console.log('Widget created with ID: ', widgetRef.id);
    return widgetRef.id;
  } catch (error) {
    // console.error('Error creating widget:', error);
    throw error;
  }
}

// Function to fetch widgets from the 'admin-widgets' collection
async function fetchWidgets() {
  try {
    const snapshot = await db.collection('admin-widgets')
      .orderBy('created_at', 'desc')
      .get();
    const widgets = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));
    return widgets;
  } catch (error) {
    // console.error('Error fetching widgets:', error);
    return [];
  }
}

// Function to delete a widget from the 'admin-widgets' collection
async function deleteWidget(widgetId) {
  try {
    await db.collection('admin-widgets').doc(widgetId).delete();
    // console.log('Widget deleted with ID:', widgetId);
  } catch (error) {
    // console.error('Error deleting widget:', error);
    throw error;
  }
}

// Function to upload widget image to Firebase Storage
async function uploadWidgetImage(file, widgetId) {
  const storageRef = storage.ref();
  const fileRef = storageRef.child(`widget_images/${widgetId}_${file.name}`);
  
  try {
    const uploadTaskSnapshot = await fileRef.put(file);
    const imageUrl = await uploadTaskSnapshot.ref.getDownloadURL();
    // console.log('Widget image available at:', imageUrl);
    return imageUrl;
  } catch (error) {
    // console.error('Error uploading widget image:', error);
    throw error;
  }
}

async function fetchFamilyUsers() {
  try {
    const snapshot = await db.collection('users').where('role', '==', 'family').get();
    const users = await Promise.all(snapshot.docs.map(async doc => {
      const userData = doc.data();
      const disabledStatus = await fetchUserStatus(doc.id); // Fetch disabled status
      return {
        id: doc.id,
        ...userData,

        active: !disabledStatus, // Active is the opposite of disabled
      };
    }));

    return users;
  } catch (error) {
    // console.error("Error fetching family users:", error);
    return [];
  }
}
async function updateUser(userId, updatedData) {
  try {
    // console.log("Updating user with ID:", userId, "Data:", updatedData);

    // If `firstName` and `lastName` are provided, create a `name` field
    if (updatedData.firstName && updatedData.lastName) {
      updatedData.name = `${updatedData.firstName} ${updatedData.lastName}`;
    }
      
    // Check if the address is updated and generate new latitude/longitude
    if (updatedData.postcode) {
      const { latitude, longitude } = await geocodeAddress(updatedData.postcode);
      updatedData.latitude = latitude.toString();
      updatedData.longitude = longitude.toString();
    }

    // Update Firestore user data
    await db.collection('users').doc(userId).update(updatedData);

    // If the name is being updated, update the currently signed-in user's displayName
    if (updatedData.name && currentUser && currentUser.uid === userId) {
      await currentUser.updateProfile({ displayName: updatedData.name });
    }

    // console.log("User updated successfully.");
  } catch (error) {
    // console.error("Error updating user:", error);
    throw error;
  }
}


async function fetchUserStatus(userId) {
  try {
    const checkStatus = functions.httpsCallable('checkUserStatus');
    const response = await checkStatus({ userId });
    return response.data.disabled; // Return disabled status (true/false)
  } catch (error) {
    // console.error('Error fetching user status:', error);
    return null; // Handle error appropriately
  }
}

async function fetchBusinessUsers() {
  try {
    const snapshot = await db.collection('users')
      .where('role', '==', 'business')
      .where('approved', '==', true)
      .get();
    const users = await Promise.all(snapshot.docs.map(async doc => {
      const userData = doc.data();
      const disabledStatus = await fetchUserStatus(doc.id); // Fetch disabled status
      return {
        id: doc.id,
        ...userData,
        active: !disabledStatus, // Active is the opposite of disabled
      };
    }));

    return users;
  } catch (error) {
    // console.error("Error fetching business users:", error);
    return [];
  }
}

async function updateBusiness(businessId, updatedData) {
  try {
    // console.log("Updating business with ID:", businessId, "Data:", updatedData);
    // Update Firestore user data
    await db.collection('users').doc(businessId).update(updatedData);
    
     // Check if the location is updated and generate new latitude/longitude
     if (updatedData.location) {
      const { latitude, longitude } = await geocodeAddress(updatedData.location);
      updatedData.latitude = latitude.toString();
      updatedData.longitude = longitude.toString();
    }

    
    // If the name is being updated, update the currently signed-in user's displayName
    if (updatedData.name && currentUser && currentUser.uid === businessId) {
      await currentUser.updateProfile({ displayName: updatedData.name });
    }

    // console.log("Business updated successfully.");
  } catch (error) {
    // console.error("Error updating business:", error);
    throw error;
  }
}  // Updated fetchPendingBusinessUsers to exclude denied businesses
async function fetchPendingBusinessUsers() {
  try {
    const snapshot = await db.collection('users')
      .where('role', '==', 'business')
      .where('approved', '==', false)
      .where('denied', '==', false) // Exclude denied businesses
      .get();
    const users = snapshot.docs.map(doc => {
      const userData = doc.data();
      return {
        id: doc.id,
        ...userData
      };
    });
    // console.log("Pending approval businesses: ", users);
    return users;
  } catch (error) {
    // console.error("Error fetching pending business users:", error);
    return [];
  }
}

async function approveBusinessUser(businessId) {
  try {
    await db.collection('users').doc(businessId).update({
      approved: true
    });
    // console.log("Business approved successfully:", businessId);
  } catch (error) {
    // console.error("Error approving business:", error);
  }
}

async function denyBusinessUser(businessId) {
  try {
    await db.collection('users').doc(businessId).update({
      denied: true  // Optionally set 'denied' field or delete the document
    });
    // console.log("Business denied successfully:", businessId);
  } catch (error) {
    // console.error("Error denying business:", error);
  }
}

const claimServiceForBusiness = async (serviceId, businessId) => {
  const businessRef = db.collection('users').doc(businessId);

  return db.runTransaction(async (transaction) => {
    // Store claimed service data in business's document under 'claimedServices' subcollection
    transaction.set(businessRef.collection('claimedServices').doc(serviceId), {
      serviceId: serviceId,
      claimDate: Timestamp.now(),
      status: 'pending' // Mark the claim as pending for admin approval
    });
  });
};

async function fetchPendingServiceClaims() {
  // console.log('Fetching all approved business users for service claims...'); // Debug
  try {
    const businesses = await fetchBusinessUsers(); // Fetch all approved business users
    const pendingClaims = [];

    for (const business of businesses) {
      const claimedServicesSnapshot = await db
        .collection('users')
        .doc(business.id)
        .collection('claimedServices')
        .where('status', '==', 'pending')
        .get();

      // console.log(`Fetching pending claims for business ${business.id}...`); // Debug

      // Fetch each service detail from the services collection
      for (const doc of claimedServicesSnapshot.docs) {
        const claimData = doc.data();
        const serviceRef = db.collection('services').doc(claimData.serviceId);
        const serviceDoc = await serviceRef.get();

        if (serviceDoc.exists) {
          const serviceData = serviceDoc.data();
          // console.log(`Found pending claim with service details:`, serviceData); // Debug
          pendingClaims.push({
            key: `${business.id}_${doc.id}`,
            businessId: business.id,
            businessName: business.name,
            serviceId: claimData.serviceId,
            serviceName: serviceData.name,
            serviceDetails: serviceData.description,
            category: serviceData.category.join(', '), // Join categories as a string
            address: serviceData.address,
            email: serviceData.email,
            phone_number: serviceData.phone_number,
            website: serviceData.website,
            claimDate: claimData.claimDate.toDate().toString(),
            status: claimData.status,
          });
        }
      }
    }

    // console.log('All pending service claims:', pendingClaims); // Debug
    return pendingClaims;
  } catch (error) {
    // console.error("Error fetching pending service claims:", error);
    throw error;
  }
}


// Function to approve a service claim
async function approveServiceClaim(serviceId, businessId) {
  const businessRef = db.collection('users').doc(businessId);
  const serviceRef = db.collection('services').doc(serviceId);
  const claimedServiceRef = businessRef.collection('claimedServices').doc(serviceId);

  try {
    await db.runTransaction(async (transaction) => {
      const serviceDoc = await transaction.get(serviceRef);
      if (!serviceDoc.exists) {
        throw new Error('Service does not exist!');
      }

      // Check if the service is already claimed
      if (serviceDoc.data().claimed) {
        throw new Error('Service is already claimed!');
      }

      // Approve the claim in claimedServices subcollection
      transaction.update(claimedServiceRef, {
        status: 'approved',
        approvedAt: Timestamp.now(),
      });

      // Update the service document
      transaction.update(serviceRef, {
        claimed: true,
        claimedBy: businessId,
        claimDate: Timestamp.now(),
      });
    });
  } catch (error) {
    // console.error("Error approving service claim:", error);
    throw error; // Let the caller handle the error
  }
}

// Function to deny a service claim
async function denyServiceClaim(serviceId, businessId) {
  const businessRef = db.collection('users').doc(businessId);
  const claimedServiceRef = businessRef.collection('claimedServices').doc(serviceId);

  try {
    await claimedServiceRef.update({
      status: 'denied',
      deniedAt: Timestamp.now(),
    });
  } catch (error) {
    //  console.error("Error denying service claim:", error);
    throw error; // Let the caller handle the error
  }
}
async function fetchClaimedServices(businessId) {
  try {
    const snapshot = await db
      .collection('users')
      .doc(businessId)
      .collection('claimedServices')
      .get();
    const claimedServices = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));

    // Fetch service details for each claimed service
    const detailedClaimedServices = await Promise.all(
      claimedServices.map(async (claim) => {
        const serviceDoc = await db.collection('services').doc(claim.serviceId).get();
        if (serviceDoc.exists) {
          return {
            ...claim,
            serviceDetails: serviceDoc.data(),
            serviceName: serviceDoc.data().name,
          };
        } else {
          return {
            ...claim,
            serviceDetails: null,
            serviceName: 'Service Not Found',
          };
        }
      })
    );

    return detailedClaimedServices;
  } catch (error) {
    // console.error('Error fetching claimed services:', error);
    throw error;
  }
}
async function uploadBusinessProfilePicture(businessId, file) {
  const storageRef = storage.ref();
  const fileRef = storageRef.child(`business_profile_pictures/${businessId}_${Date.now()}`);
  try {
    await fileRef.put(file);
    const imageUrl = await fileRef.getDownloadURL();
    return imageUrl;
  } catch (error) {
    // console.error('Error uploading profile picture:', error);
    throw error;
  }
}

// Function to upload business documents
async function uploadBusinessDocument(businessId, file) {
  const storageRef = storage.ref();
  const fileRef = storageRef.child(`business_documents/${businessId}/${file.name}_${Date.now()}`);
  try {
    await fileRef.put(file);
    const documentUrl = await fileRef.getDownloadURL();
    return documentUrl;
  } catch (error) {
    // console.error('Error uploading document:', error);
    throw error;
  }
}

// Function to fetch admin users
async function fetchAdminUsers() {
  try {
    // console.log('Starting fetchAdminUsers...');
    const snapshot = await db.collection('users').where('role', '==', 'admin').get();
    // console.log('Number of admin users found:', snapshot.docs.length);
    
    const admins = snapshot.docs.map((doc) => {
      const userData = doc.data();
      // console.log('Admin user found:', { id: doc.id, name: userData.name, email: userData.email });
      return {
        id: doc.id,
        ...userData,
      };
    });
    
    // console.log('Returning admin users:', admins);
    return admins;
  } catch (error) {
    // console.error('Error fetching admin users:', error);
    throw error;
  }
}



async function fetchServicesClaimedByBusiness(businessId) {
  try {
    const snapshot = await db
      .collection('services')
      .where('claimedBy', '==', businessId)
      .get();
    const services = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    return services;
  } catch (error) {
    // console.error('Error fetching claimed services:', error);
    throw error;
  }
}

// // Function to create a new service
// async function createService(serviceData, imageFile, markerImageFile) {
//   try {
//     // Upload images to Firebase Storage
//     const imageUrl = await uploadServiceImage(imageFile);
//     const markerImageUrl = await uploadServiceImage(markerImageFile);

//     // Get latitude and longitude from address using geocoding API
//     const { latitude, longitude } = await geocodeAddress(serviceData.address);

//     // Prepare service data
//     const newService = {
//       ...serviceData,
//       image: imageUrl,
//       marker_image: markerImageUrl,
//       claimedBy: currentUser.uid,
//       claimed: true,
//       claimDate: firebase.firestore.Timestamp.now(),
//       latitude: latitude.toString(),
//       longitude: longitude.toString(),
//     };

//     // Add service to Firestore
//     const serviceRef = await db.collection('services').add(newService);

//     // Update items.json
//     await updateItemsJson();

//     console.log('Service created with ID:', serviceRef.id);
//     return serviceRef.id;
//   } catch (error) {
//     console.error('Error creating service:', error);
//     throw error;
//   }
// }
async function createService(serviceData) {
  try {
    // Get latitude and longitude from address using geocoding API
    const { latitude, longitude } = await geocodeAddress(serviceData.address);

    // Prepare service data
    const newService = {
      ...serviceData,
      claimedBy: currentUser.uid,
      claimed: true,
      claimDate: firebase.firestore.Timestamp.now(),
      latitude: latitude.toString(),
      longitude: longitude.toString(),
    };

    // Add service to Firestore
    const serviceRef = await db.collection('services').add(newService);
    const serviceId = serviceRef.id;

    // Call the custom function to create a Stripe product and price
    const createStripeProduct = functions.httpsCallable('createStripeProduct');
    const productResponse = await createStripeProduct({
      serviceId: serviceId,
      serviceName: newService.name,
      price: newService.price, // Ensure 'price' is part of serviceData
    });

    // Update the service document with the Stripe product and price IDs
    await serviceRef.update({
      stripeProductId: productResponse.data.productId,
      stripePriceId: productResponse.data.priceId,
    });

    // Update items.json if necessary
    await updateItemsJson();

    // console.log('Service created with ID:', serviceId);
    return serviceId;
  } catch (error) {
    // console.error('Error creating service:', error);
    throw error;
  }
}


async function updateService(serviceId, serviceData) {
  try {
    await db.collection('services').doc(serviceId).update(serviceData);
    await updateItemsJson();
    // console.log('Service updated with ID:', serviceId);
    return serviceId;
  } catch (error) {
    // console.error('Error updating service:', error);
    throw error;
  }
}


// Function to delete a service and all associated data
async function deleteService(serviceId) {
  try {
    // Start a batch operation for atomic deletion
    const batch = db.batch();
    
    // 1. Delete all time slots and their bookings
    const timeSlotsSnapshot = await db.collection('services').doc(serviceId).collection('timeSlots').get();
    for (const timeSlotDoc of timeSlotsSnapshot.docs) {
      // Delete all bookings for this time slot
      const bookingsSnapshot = await timeSlotDoc.ref.collection('bookings').get();
      bookingsSnapshot.docs.forEach(bookingDoc => {
        batch.delete(bookingDoc.ref);
      });
      // Delete the time slot itself
      batch.delete(timeSlotDoc.ref);
    }
    
    // 2. Delete all reviews for the service
    const reviewsSnapshot = await db.collection('services').doc(serviceId).collection('reviews').get();
    reviewsSnapshot.docs.forEach(reviewDoc => {
      batch.delete(reviewDoc.ref);
    });
    
    // 3. Remove service from all users' favorite lists
    const usersWithFavoriteSnapshot = await db.collection('users')
      .where('favoriteServices', 'array-contains', serviceId)
      .get();
    
    usersWithFavoriteSnapshot.docs.forEach(userDoc => {
      batch.update(userDoc.ref, {
        favoriteServices: firebase.firestore.FieldValue.arrayRemove(serviceId)
      });
    });
    
    // 4. Remove claimed service records from businesses
    const businessesSnapshot = await db.collection('users').where('role', '==', 'business').get();
    for (const businessDoc of businessesSnapshot.docs) {
      const claimedServiceRef = businessDoc.ref.collection('claimedServices').doc(serviceId);
      const claimedServiceDoc = await claimedServiceRef.get();
      if (claimedServiceDoc.exists) {
        batch.delete(claimedServiceRef);
      }
    }
    
    // 5. Delete the service document itself
    batch.delete(db.collection('services').doc(serviceId));
    
    // Execute all deletions atomically
    await batch.commit();
    
    // Update items.json after successful deletion
    await updateItemsJson();

    // console.log('Service and all associated data deleted successfully:', serviceId);
  } catch (error) {
    // console.error('Error deleting service:', error);
    throw error;
  }
}


async function uploadServiceImage(file) {
  if (!file) return ''; // Return empty string if no file provided
  const storageRef = storage.ref();
  const fileRef = storageRef.child(`service_images/${file.name}_${Date.now()}`);
  try {
    const uploadTaskSnapshot = await fileRef.put(file);
    const imageUrl = await uploadTaskSnapshot.ref.getDownloadURL();
    // console.log('Service image uploaded at:', imageUrl);
    return imageUrl;
  } catch (error) {
    // console.error('Error uploading service image:', error);
    throw error;
  }
}

// Function to geocode address
async function geocodeAddress(address) {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY; // Use an appropriately named environment variable
  // console.log("Google Maps API Key:", apiKey); // Temporary debug line

  const encodedAddress = encodeURIComponent(address);
  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${apiKey}`;

  try {
    const response = await axios.get(url);
    const data = response.data;
    if (data.status === 'OK') {
      const location = data.results[0].geometry.location;
      return { latitude: location.lat, longitude: location.lng };
    } else {
      throw new Error('Geocoding failed: ' + data.status);
    }
  } catch (error) {
    // console.error('Error geocoding address:', error);
    throw error;
  }
}


// Function to update items.json in Firebase Storage
async function updateItemsJson() {
  try {
    // Fetch all services but only send essential data to reduce payload size
    const servicesSnapshot = await db.collection('services').get();
    const allServices = servicesSnapshot.docs.map((doc) => {
      const data = doc.data();
      // Only include essential fields for the map
      return {
        id: doc.id,
        name: data.name || '',
        address: data.address || '',
        latitude: data.latitude || '',
        longitude: data.longitude || '',
        category: data.category || [],
        activities: data.activities || [],
        beneficiaries: data.beneficiaries || [],
        email: data.email || '',
        phone_number: data.phone_number || '',
        website: data.website || '',
        description: (data.description || '').substring(0, 200), // Limit description length
        price: data.price || '',
        claimed: data.claimed || false,
        image: data.image || '',
        marker_image: data.marker_image || ''
      };
    });

    // Check payload size - if too large, remove some fields
    const jsonString = JSON.stringify(allServices);
    const sizeInMB = new Blob([jsonString]).size / (1024 * 1024);
    
    console.log(`Updating items.json with ${allServices.length} services (${sizeInMB.toFixed(2)} MB)`);
    
    let servicesData = allServices;
    
    // If payload is too large (> 5MB), remove non-essential fields
    if (sizeInMB > 5) {
      console.log('Payload too large, removing non-essential fields...');
      servicesData = allServices.map(service => ({
        id: service.id,
        name: service.name,
        address: service.address,
        latitude: service.latitude,
        longitude: service.longitude,
        category: service.category,
        claimed: service.claimed
      }));
    }

    // Call the Callable Function with reduced payload
    const updateItemsJsonFunction = functions.httpsCallable('updateItemsJson');
    const result = await updateItemsJsonFunction(servicesData);

    console.log('items.json updated successfully');
  } catch (error) {
    console.error('Error updating items.json:', error);

    // Handle specific Firebase HttpsErrors
    if (error.code === 'functions/unauthenticated') {
      console.error('User is not authenticated.');
    } else if (error.code === 'functions/invalid-argument') {
      console.error('Invalid data provided.');
    } else if (error.code === 'functions/resource-exhausted' || error.message.includes('413')) {
      console.error('Payload still too large. Services data may need to be paginated.');
    } else if (error.message.includes('CORS')) {
      console.error('CORS error - this may be a secondary error. Check the Cloud Function logs.');
    } else {
      console.error('Error details:', error.message);
    }

    // Don't throw the error to prevent blocking the main operation
    // Service deletion should still work even if items.json update fails
  }
}
async function createTimeSlot(serviceId, timeSlotData) {
  try {
    const timeSlotsRef = db.collection('services').doc(serviceId).collection('timeSlots');
    const timeSlotDoc = await timeSlotsRef.add({
      ...timeSlotData,
      createdAt: Timestamp.now(),
      purchases: 0, // Initialize purchase count
    });
    return timeSlotDoc.id;
  } catch (error) {
    // console.error('Error creating time slot:', error);
    throw error;
  }
}

// In your useAuth context
async function fetchTimeSlotsWithBookings(serviceId, date) {
  try {
    const timeSlotsRef = db.collection('services').doc(serviceId).collection('timeSlots');
    let timeSlotsQuery = timeSlotsRef;

    if (date) {
      // Filter time slots by date
      timeSlotsQuery = timeSlotsRef.where('date', '==', date);
    }

    const timeSlotsSnapshot = await timeSlotsQuery.get();
    const timeSlots = [];

    for (const doc of timeSlotsSnapshot.docs) {
      const timeSlotData = doc.data();
      const timeSlotId = doc.id;

      // Fetch bookings for this time slot
      const bookingsRef = timeSlotsRef.doc(timeSlotId).collection('bookings');
      const bookingsSnapshot = await bookingsRef.get();
      const bookings = [];

      for (const bookingDoc of bookingsSnapshot.docs) {
        const bookingData = bookingDoc.data();
        const bookingId = bookingDoc.id;

        // Fetch user data
        const userDoc = await db.collection('users').doc(bookingData.userId).get();
        const userData = userDoc.exists ? userDoc.data() : {};

        bookings.push({
          id: bookingId,
          ...bookingData,
          customerName: userData.name || 'Unknown User',
          email: userData.email || '',
          timeSlotId: timeSlotId,
        });
      }

      timeSlots.push({
        id: timeSlotId,
        ...timeSlotData,
        bookings: bookings,
      });
    }

    return timeSlots;
  } catch (error) {
    // console.error('Error fetching time slots with bookings:', error);
    throw error;
  }
}



async function updateTimeSlot(serviceId, timeSlotId, timeSlotData) {
  try {
    const timeSlotRef = db.collection('services').doc(serviceId).collection('timeSlots').doc(timeSlotId);
    await timeSlotRef.update(timeSlotData);
    return timeSlotId;
  } catch (error) {
    // console.error('Error updating time slot:', error);
    throw error;
  }
}

async function deleteTimeSlot(serviceId, timeSlotId) {
  try {
    const timeSlotRef = db.collection('services').doc(serviceId).collection('timeSlots').doc(timeSlotId);
    const timeSlotDoc = await timeSlotRef.get();

    if (!timeSlotDoc.exists) {
      throw new Error('Time slot does not exist.');
    }

    const timeSlotData = timeSlotDoc.data();
    const productId = timeSlotData.productId;

    // Delete the time slot document
    await timeSlotRef.delete();

    // Call Cloud Function to archive the product
    if (productId) {
      const archiveProduct = functions.httpsCallable('archiveProduct');
      await archiveProduct({ productId: productId });
    } else {
      console.warn('No productId found for time slot:', timeSlotId);
    }

    return timeSlotId;
  } catch (error) {
    // console.error('Error deleting time slot:', error);
    throw error;
  }
}


async function updateBookingStatus(serviceId, timeSlotId, bookingId, status) {
  try {
    const bookingRef = db.collection('services').doc(serviceId)
      .collection('timeSlots').doc(timeSlotId)
      .collection('bookings').doc(bookingId);
    await bookingRef.update({ bookingStatus: status });
    return bookingId;
  } catch (error) {
    // console.error('Error updating booking status:', error);
    throw error;
  }
}

async function UpdateTimeSlotAvail(serviceId, timeSlotId) {
  const timeSlotRef = db.collection('services').doc(serviceId).collection('timeSlots').doc(timeSlotId);

  // Fetch the current time slot to get the number of purchases
  const doc = await timeSlotRef.get();
  if (doc.exists) {
    const currentPurchases = doc.data().purchases || 0; // Default to 0 if purchases field is undefined

    // Update availability in Firestore by incrementing purchases
    await timeSlotRef.update({
      purchases: currentPurchases + 1, // Increment purchases
    });
  } else {
    // console.error('Time slot does not exist');
    // Optionally, handle the case where the timeslot doesn't exist
  }
}

async function getTimeSlotAvailability(serviceId, timeSlotId) {
  const timeSlotRef = db.collection('services').doc(serviceId).collection('timeSlots').doc(timeSlotId);
  const timeSlotDoc = await timeSlotRef.get();
  if (!timeSlotDoc.exists) {
    throw new Error('Time slot does not exist.');
  }
  const timeSlotData = timeSlotDoc.data();
  const spotsLeft = timeSlotData.availability - (timeSlotData.purchases || 0);
  return spotsLeft;
}

// Function to add a review to a product
async function addReviewToProduct(productId, rating, comment) {
  if (!currentUser) {
      throw new Error("User not authenticated");
  }

  const review = {
      userId: currentUser.uid,
      userName: currentUser.displayName || "Anonymous",
      rating: rating,
      comment: comment,
      createdAt: Timestamp.now(),
  };

  try {
      await db.collection('admin-products').doc(productId).collection('reviews').add(review);
      // console.log("Review added successfully");
  } catch (error) {
      // console.error("Error adding review:", error);
      throw error;
  }
}

// Function to fetch reviews for a product with real-time updates
function fetchReviewsForProduct(productId, callback) {
  const reviewsRef = db.collection('admin-products').doc(productId).collection('reviews').orderBy('createdAt', 'desc');
  const unsubscribe = reviewsRef.onSnapshot(snapshot => {
      const reviews = [];
      snapshot.forEach(doc => {
          reviews.push({ id: doc.id, ...doc.data() });
      });
      callback(reviews);
  }, error => {
      // console.error("Error fetching reviews:", error);
  });

  return unsubscribe; // Return unsubscribe function to stop listening
}


async function fetchLocalAuthorityUsers() {
  try {
      const snapshot = await db.collection('users')
          .where('role', '==', 'local-authority')
          .where('approved', '==', true)
          .where('denied', '==', false)
          .get();
      const users = await Promise.all(snapshot.docs.map(async doc => {
          const userData = doc.data();
          const disabledStatus = await fetchUserStatus(doc.id);
          return {
              id: doc.id,
              ...userData,
              active: !disabledStatus,
          };
      }));
      return users;
  } catch (error) {
      // console.error("Error fetching local authority users:", error);
      return [];
  }
}

// Fetch pending local authority users
async function fetchPendingLocalAuthorityUsers() {
  try {
      const snapshot = await db.collection('users')
          .where('role', '==', 'local-authority')
          .where('approved', '==', false)
          .where('denied', '==', false)
          .get();
      const users = snapshot.docs.map(doc => {
          const userData = doc.data();
          return {
              id: doc.id,
              ...userData
          };
      });
      return users;
  } catch (error) {
      // console.error("Error fetching pending local authority users:", error);
      return [];
  }
}

// Approve a local authority user
async function approveLocalAuthorityUser(localAuthId) {
  try {
      await db.collection('users').doc(localAuthId).update({
          approved: true
      });
      // console.log("Local Authority approved successfully:", localAuthId);
  } catch (error) {
      // console.error("Error approving local authority:", error);
      throw error;
  }
}

// Deny a local authority user
async function denyLocalAuthorityUser(localAuthId) {
  try {
      await db.collection('users').doc(localAuthId).update({
          denied: true
      });
      // console.log("Local Authority denied successfully:", localAuthId);
  } catch (error) {
      // console.error("Error denying local authority:", error);
      throw error;
  }
}

  // Add the fetchUpcomingBookings function here
  async function fetchUpcomingBookings(userId, childId = null) {
    try {
      let query = db
        .collection('users')
        .doc(userId)
        .collection('bookings')
        .orderBy('date', 'asc');

      if (childId) {
        query = query.where('childId', '==', childId);
      }

      const bookingsSnapshot = await query.get();
      const bookings = bookingsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      // Filter for upcoming bookings (dates >= today)
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      return bookings.filter(booking => {
        const bookingDate = new Date(booking.date);
        return bookingDate >= today;
      });
    } catch (error) {
      // console.error('Error fetching upcoming bookings:', error);
      throw error;
    }
  }
  

   // Function to add a favorite service
   const addFavoriteService = async (userId, serviceId) => {
    try {
        const userRef = db.collection('users').doc(userId);
        await userRef.update({
            favoriteServices: firebase.firestore.FieldValue.arrayUnion(serviceId)
        });
        // console.log(`Service ${serviceId} added to favorites for user ${userId}`);
    } catch (error) {
        // console.error("Error adding favorite service:", error);
        throw error;
    }
};

// Function to remove a favorite service
const removeFavoriteService = async (userId, serviceId) => {
    try {
        const userRef = db.collection('users').doc(userId);
        await userRef.update({
            favoriteServices: firebase.firestore.FieldValue.arrayRemove(serviceId)
        });
        // console.log(`Service ${serviceId} removed from favorites for user ${userId}`);
    } catch (error) {
        // console.error("Error removing favorite service:", error);
        throw error;
    }
};

// Function to add a favorite product
const addFavoriteProduct = async (userId, productId) => {
    try {
        const userRef = db.collection('users').doc(userId);
        await userRef.update({
            favoriteProducts: firebase.firestore.FieldValue.arrayUnion(productId)
        });
        // console.log(`Product ${productId} added to favorites for user ${userId}`);
    } catch (error) {
        // console.error("Error adding favorite product:", error);
        throw error;
    }
};

// Function to remove a favorite product
const removeFavoriteProduct = async (userId, productId) => {
    try {
        const userRef = db.collection('users').doc(userId);
        await userRef.update({
            favoriteProducts: firebase.firestore.FieldValue.arrayRemove(productId)
        });
        // console.log(`Product ${productId} removed from favorites for user ${userId}`);
    } catch (error) {
        // console.error("Error removing favorite product:", error);
        throw error;
    }
};



// useEffect(() => {
//   const unsubscribe = auth.onAuthStateChanged(async (user) => {
//       setCurrentUser(user);
//       setLoading(false);

//       if (user) {
//           try {
//               const userDoc = await db.collection('users').doc(user.uid).get();
//               if (userDoc.exists) {
//                   setUserInfo({ id: userDoc.id, ...userDoc.data() });
//               } else {
//                   setUserInfo(null);
//               }
//           } catch (error) {
//               console.error('Error fetching user info:', error);
//               setUserInfo(null);
//           }
//       } else {
//           setUserInfo(null);
//       }
//   });

//   return unsubscribe;
// }, []);
async function fetchUserReportData(userId) {
  try {
    // Fetch user document
    const userDoc = await db.collection('users').doc(userId).get();
    const userData = userDoc.data();

    // Fetch user's bookings
    const bookings = await fetchUserBookings(userId);

    // Fetch favorite services and products
    const favoriteServices = await fetchServicesByIds(userData.favoriteServices || []);
    const favoriteProducts = await fetchProductsByIds(userData.favoriteProducts || []);

    // Compile all data
    return {
      ...userData,
      bookings,
      favoriteServices,
      favoriteProducts,
    };
  } catch (error) {
    // console.error('Error fetching user report data:', error);
    throw error;
  }
}


async function fetchBusinessReportData(businessId) {
  try {
    // Fetch business user document
    const businessDoc = await db.collection('users').doc(businessId).get();
    const businessData = businessDoc.data();

    // Fetch services claimed or created by the business
    const services = await fetchServicesByBusiness(businessId);

    // Fetch bookings for those services
    const bookings = await fetchBookingsForBusinessServices(services);

    // Compile all data
    return {
      ...businessData,
      services,
      bookings,
    };
  } catch (error) {
    // console.error('Error fetching business report data:', error);
    throw error;
  }
}

async function fetchLocalAuthorityReportData(localAuthId) {
  try {
    // Fetch local authority user document
    const localAuthDoc = await db.collection('users').doc(localAuthId).get();
    const localAuthData = localAuthDoc.data();

    // Fetch services under their jurisdiction (if applicable)
    const services = await fetchServicesByLocalAuthority(localAuthId);

    // Compile all data
    return {
      ...localAuthData,
      services,
    };
  } catch (error) {
      // console.error('Error fetching local authority report data:', error);
    throw error;
  }
}
async function fetchUserBookings(userId) {
  try {
    const bookingsSnapshot = await db
      .collection('users')
      .doc(userId)
      .collection('bookings')
      .orderBy('date', 'desc')
      .get();

    return bookingsSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    // console.error('Error fetching user bookings:', error);
    throw error;
  }
}
async function fetchServicesByIds(serviceIds) {
  try {
    if (serviceIds.length === 0) return [];
    const services = [];
    for (const serviceId of serviceIds) {
      const serviceDoc = await db.collection('services').doc(serviceId).get();
      if (serviceDoc.exists) {
        services.push({ id: serviceId, ...serviceDoc.data() });
      }
    }
    return services;
  } catch (error) {
    // console.error('Error fetching services by IDs:', error);
    throw error;
  }
}
async function fetchProductsByIds(productIds) {
  try {
    if (productIds.length === 0) return [];
    const products = [];
    for (const productId of productIds) {
      const productDoc = await db.collection('admin-products').doc(productId).get();
      if (productDoc.exists) {
        products.push({ id: productId, ...productDoc.data() });
      }
    }
    return products;
  } catch (error) {
    // console.error('Error fetching products by IDs:', error);
    throw error;
  }
}
async function fetchUserMessages(userId) {
  try {
    const messages = [];
    const conversationsSnapshot = await db
      .collection('users')
      .doc(userId)
      .collection('conversations')
      .get();

    for (const convoDoc of conversationsSnapshot.docs) {
      const conversationId = convoDoc.id;
      const messagesSnapshot = await db
        .collection('messages')
        .doc(conversationId)
        .collection('messages')
        .orderBy('timestamp', 'asc')
        .get();

      messagesSnapshot.forEach((msgDoc) => {
        messages.push({ id: msgDoc.id, ...msgDoc.data() });
      });
    }

    return messages;
  } catch (error) {
    // console.error('Error fetching user messages:', error);
    throw error;
  }
}
async function fetchServicesByBusiness(businessId) {
  try {
    const servicesSnapshot = await db
      .collection('services')
      .where('claimedBy', '==', businessId)
      .get();

    const services = servicesSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    return services;
  } catch (error) {
    // console.error('Error fetching services by business:', error);
    throw error;
  }
}
async function fetchBookingsForBusinessServices(services) {
  try {
    const bookings = [];
    for (const service of services) {
      const timeSlotsSnapshot = await db
        .collection('services')
        .doc(service.id)
        .collection('timeSlots')
        .get();

      for (const timeSlotDoc of timeSlotsSnapshot.docs) {
        const timeSlotId = timeSlotDoc.id;
        const bookingsSnapshot = await db
          .collection('services')
          .doc(service.id)
          .collection('timeSlots')
          .doc(timeSlotId)
          .collection('bookings')
          .get();

        for (const bookingDoc of bookingsSnapshot.docs) {
          const bookingData = bookingDoc.data();
          const userDoc = await db.collection('users').doc(bookingData.userId).get();
          const userName = userDoc.exists ? userDoc.data().name : 'Unknown User';

          // Fetch payment details from Stripe if paymentId exists
          let paymentDetails = null;
          // if (bookingData.paymentId) {
          //   paymentDetails = await fetchPaymentDetails(bookingData.paymentId);
          // }

          bookings.push({
            serviceName: service.name,
            serviceId: service.id,
            timeSlotId: timeSlotId,
            customerName: userName,
            bookingStatus: bookingData.bookingStatus || 'Confirmed',
            paymentId: bookingData.paymentId || null,
            paymentDetails: paymentDetails || null,
            timestamp: bookingData.timestamp.toDate(),
          });
        }
      }
    }
    return bookings;
  } catch (error) {
    // console.error('Error fetching bookings for business services:', error);
    throw error;
  }
}
async function fetchServicesByLocalAuthority(localAuthId) {
  try {
    const servicesSnapshot = await db
      .collection('services')
      .where('localAuthorityId', '==', localAuthId)
      .get();

    const services = servicesSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    return services;
  } catch (error) {
    // console.error('Error fetching services by local authority:', error);
    throw error;
  }
}

useEffect(() => {
  const unsubscribe = auth.onAuthStateChanged(async (user) => {
      setCurrentUser(user);
      setLoading(false);

      if (user) {
          try {
              const userDoc = await db.collection('users').doc(user.uid).get();
              if (userDoc.exists) {
                  setUserInfo({ id: userDoc.id, ...userDoc.data() });

                  // Listen for real-time updates to user's document
                  db.collection('users').doc(user.uid)
                      .onSnapshot(doc => {
                          if (doc.exists) {
                              setUserInfo({ id: doc.id, ...doc.data() });
                          }
                      }, error => {
                        // console.error('Error listening to user document:', error);
                      });
              } else {
                  setUserInfo(null);
              }
          } catch (error) {
              // console.error('Error fetching user info:', error);
              setUserInfo(null);
          }
      } else {
          setUserInfo(null);
      }
  });

  return unsubscribe;
}, []);

// Function to add a review to a service
async function addReviewToService(serviceId, rating, comment) {
    if (!currentUser) {
        throw new Error("User not authenticated");
    }

    const review = {
        userId: currentUser.uid,
        userName: currentUser.displayName || "Anonymous",
        rating: rating,
        comment: comment,
        createdAt: Timestamp.now(),
    };

    try {
        await db.collection('services').doc(serviceId).collection('reviews').add(review);
        // console.log("Review added successfully");
    } catch (error) {
        // console.error("Error adding review:", error);
        throw error;
    }
}

// Function to fetch reviews for a service with real-time updates
function fetchReviewsForService(serviceId, callback) {
    const reviewsRef = db.collection('services').doc(serviceId).collection('reviews')
        .orderBy('createdAt', 'desc');
    
    const unsubscribe = reviewsRef.onSnapshot(snapshot => {
        const reviews = [];
        snapshot.forEach(doc => {
            reviews.push({ id: doc.id, ...doc.data() });
        });
        callback(reviews);
    }, error => {
              // console.error("Error fetching reviews:", error);
    });

    return unsubscribe;
}


async function importServicesFromJson(jsonData) {
  let importCount = 0;
  const BATCH_SIZE = 100; // Reduced from 500 to be more conservative
  const DELAY_BETWEEN_BATCHES = 1000; // 1 second delay between batches

  try {
    // Get all existing services
    const snapshot = await db.collection('services').get();
    const existingServices = new Map();
    
    snapshot.docs.forEach(doc => {
      existingServices.set(doc.data().name.toLowerCase(), doc.id);
    });
    
    console.log(`Found ${existingServices.size} existing services`);

    // Track services to be imported
    const servicesToImport = [];

    // Check each service
    for (const serviceData of jsonData) {
      const serviceName = serviceData.name.toLowerCase();
      
      if (existingServices.has(serviceName)) {
        console.log(`Skipping duplicate service: ${serviceData.name}`);
        continue;
      }

      servicesToImport.push(serviceData);
      existingServices.set(serviceName, 'pending'); // Mark as pending import
    }

    console.log(`Preparing to import ${servicesToImport.length} new services`);

    // If no new services to import, exit early
    if (servicesToImport.length === 0) {
      console.log('No new services to import');
      return { imported: 0, total: 0 };
    }

    // Import services in smaller batches with delays
    for (let i = 0; i < servicesToImport.length; i += BATCH_SIZE) {
      const batch = db.batch();
      const currentBatch = servicesToImport.slice(i, i + BATCH_SIZE);
      const batchNumber = Math.floor(i / BATCH_SIZE) + 1;
      const totalBatches = Math.ceil(servicesToImport.length / BATCH_SIZE);

      console.log(`Processing batch ${batchNumber} of ${totalBatches} (${currentBatch.length} services)`);

      for (const serviceData of currentBatch) {
        const newService = {
          name: serviceData.name,
          address: serviceData.address || '',
          latitude: serviceData.latitude || '0',
          longitude: serviceData.longitude || '0',
          email: serviceData.email || '',
          phone_number: serviceData.phone_number || '',
          website: serviceData.website || '',
          claimed: serviceData.claimed || false,
          activities: serviceData.activities || [],
          beneficiaries: serviceData.beneficiaries || [],
          category: serviceData.category || [],
          description: serviceData.description || '',
          price: serviceData.price || 0,
          image: serviceData.image || "https://firebasestorage.googleapis.com/v0/b/accesssend.appspot.com/o/service_images%2Fenablelogo.png?alt=media&token=ad492348-995f-41bf-8bcf-facc27dc1204",
          marker_image: serviceData.marker_image || "https://firebasestorage.googleapis.com/v0/b/accesssend.appspot.com/o/service_images%2Fenablelogo.png?alt=media&token=ad492348-995f-41bf-8bcf-facc27dc1204",
          importedAt: Timestamp.now()
        };

        const docRef = db.collection('services').doc();
        batch.set(docRef, newService);
        importCount++;
      }

      try {
        await batch.commit();
        console.log(`Successfully committed batch ${batchNumber} (${currentBatch.length} services)`);
        
        // Add delay between batches to avoid rate limiting
        if (i + BATCH_SIZE < servicesToImport.length) {
          console.log(`Waiting ${DELAY_BETWEEN_BATCHES}ms before next batch...`);
          await new Promise(resolve => setTimeout(resolve, DELAY_BETWEEN_BATCHES));
        }
      } catch (batchError) {
        console.error(`Error committing batch ${batchNumber}:`, batchError);
        // Continue with the next batch instead of failing completely
      }
    }

    console.log(`Import completed. Successfully imported ${importCount} services`);
    
    // Skip updateItemsJson for large imports to avoid additional rate limiting
    if (importCount < 50) {
      try {
        await updateItemsJson();
      } catch (updateError) {
        console.error('Error updating items.json:', updateError);
        // Don't fail the import if items.json update fails
      }
    } else {
      console.log('Skipping items.json update due to large import. Run it manually later.');
    }
    
    return { imported: importCount, total: servicesToImport.length };
    
  } catch (error) {
    console.error('Error importing services:', error);
    throw error;
  }
}

async function fetchAdminUserBookings(userId, childId = null) {
  try {
    let query = db
      .collection('users')
      .doc(userId)
      .collection('bookings')
      .orderBy('date', 'desc');

    if (childId) {
      query = query.where('childId', '==', childId);
    }

    const bookingsSnapshot = await query.get();
    return bookingsSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    //    console.error('Error fetching admin user bookings:', error);
    throw error;
  }
}

// Function to delete a review from a service
async function deleteServiceReview(serviceId, reviewId) {
  try {
    await db.collection('services').doc(serviceId).collection('reviews').doc(reviewId).delete();
    // console.log("Review deleted successfully");
  } catch (error) {
    // console.error("Error deleting review:", error);
    throw error;
  }
}

async function deleteBlog(blogId) {
  try {
    await db.collection('blogs').doc(blogId).delete();
    // console.log('Blog deleted successfully');
  } catch (error) {
    // console.error('Error deleting blog:', error);
    throw error;
  }
}

async function deleteBlogComment(blogId, commentId) {
  try {
    const blogRef = db.collection('blogs').doc(blogId);
    const blogDoc = await blogRef.get();
    if (blogDoc.exists) {
      const currentComments = blogDoc.data().comments || [];
      const updatedComments = currentComments.filter(comment => comment.id !== commentId);
      await blogRef.update({ comments: updatedComments });
      // console.log("Comment deleted successfully");
    }
  } catch (error) {
    // console.error("Error deleting comment:", error);
    throw error;
  }
}

// Function to delete a product review
async function deleteProductReview(productId, reviewId) {
  try {
    await db.collection('admin-products').doc(productId).collection('reviews').doc(reviewId).delete();
    // console.log("Product review deleted successfully");
  } catch (error) {
    // console.error("Error deleting product review:", error);
    throw error;
  }
}

// PDF Management Functions
async function uploadPDFFile(file) {
  const storageRef = storage.ref();
  const fileRef = storageRef.child(`resource_pdfs/${Date.now()}_${file.name}`);
  try {
    const uploadTaskSnapshot = await fileRef.put(file);
    const fileUrl = await uploadTaskSnapshot.ref.getDownloadURL();
    // console.log('PDF file available at:', fileUrl);
    return fileUrl;
  } catch (error) {
    // console.error('Error uploading PDF file:', error);
    throw error;
  }
}

async function createPDF(pdfData) {
  try {
    const pdfRef = await db.collection('resource-pdfs').add({
      ...pdfData,
      created_at: Timestamp.now(),
      updated_at: Timestamp.now(),
    });
    // console.log('PDF created with ID: ', pdfRef.id);
    return pdfRef.id;
  } catch (error) {
    // console.error('Error creating PDF:', error);
    throw error;
  }
}

async function fetchPDFs(category = null) {
  try {
    let query = db.collection('resource-pdfs');
    
    if (category) {
      query = query.where('category', '==', category);
    } else {
      // Only apply ordering when not filtering by category
      query = query.orderBy('created_at', 'desc');
    }
    
    const snapshot = await query.get();
    const pdfs = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));
    
    // If filtering by category, sort in JavaScript instead
    if (category && pdfs.length > 0) {
      pdfs.sort((a, b) => {
        const aTime = a.created_at?.toDate?.() || new Date(0);
        const bTime = b.created_at?.toDate?.() || new Date(0);
        return bTime - aTime;
      });
    }
    
    return pdfs;
  } catch (error) {
    console.error('Error fetching PDFs:', error);
    return [];
  }
}

async function updatePDF(pdfId, pdfData) {
  try {
    await db.collection('resource-pdfs').doc(pdfId).update({
      ...pdfData,
      updated_at: Timestamp.now(),
    });
    // console.log('PDF updated with ID:', pdfId);
    return pdfId;
  } catch (error) {
    // console.error('Error updating PDF:', error);
    throw error;
  }
}

async function deletePDF(pdfId) {
  try {
    // Get the PDF document to retrieve the file URL
    const pdfDoc = await db.collection('resource-pdfs').doc(pdfId).get();
    if (pdfDoc.exists && pdfDoc.data().pdfUrl) {
      // Delete the file from storage
      try {
        const fileRef = storage.refFromURL(pdfDoc.data().pdfUrl);
        await fileRef.delete();
      } catch (storageError) {
        // console.error('Error deleting PDF file from storage:', storageError);
        // Continue with document deletion even if file deletion fails
      }
    }
    
    // Delete the document from Firestore
    await db.collection('resource-pdfs').doc(pdfId).delete();
    // console.log('PDF deleted with ID:', pdfId);
  } catch (error) {
    // console.error('Error deleting PDF:', error);
    throw error;
  }
}

// Function to manually update items.json (useful after large imports)
async function manualUpdateItemsJson() {
  try {
    console.log('Starting manual items.json update...');
    await updateItemsJson();
    console.log('items.json updated successfully');
    return { success: true, message: 'items.json updated successfully' };
  } catch (error) {
    console.error('Error updating items.json:', error);
    return { success: false, error: error.message };
  }
}

// Function to check import progress (useful for monitoring)
async function getServiceImportStats() {
  try {
    const snapshot = await db.collection('services').get();
    const services = snapshot.docs.map(doc => doc.data());
    
    const importedServices = services.filter(s => s.importedAt);
    const claimedServices = services.filter(s => s.claimed);
    
    return {
      totalServices: services.length,
      importedServices: importedServices.length,
      claimedServices: claimedServices.length,
      unclaimedServices: services.length - claimedServices.length
    };
  } catch (error) {
    console.error('Error getting service stats:', error);
    throw error;
  }
}

const value = {
    currentUser,
    login,
    logout,
    signUp,
    sendEmailVerification,
    forgotPassword,
    getUserInfo,
    sendMessage,
    fetchMessages,
    ensureConversationExists,
    fetchConversations,
    fetchServices,
    fetchServiceById,
    createBlog,
    updateBlog,
    uploadImage, 
    fetchBlogs, 
    fetchBlogById,
    fetchCommentsForBlog,
    addCommentToBlog,
    createProduct,    
    fetchProducts,
    updateProduct,     
    deleteProduct, 
    uploadProductImage,
    createWidget,
    deleteWidget,
    uploadWidgetImage,
    fetchWidgets,
    signUpBusiness, 
    uploadBusinessDocuments,
    fetchFamilyUsers,
    updateUser,
    fetchBusinessUsers,
    updateBusiness,
    fetchPendingBusinessUsers,
    approveBusinessUser,
    denyBusinessUser,
    fetchUserStatus,
    claimServiceForBusiness,
    fetchPendingServiceClaims,
    approveServiceClaim,
    denyServiceClaim,
    fetchClaimedServices,
    uploadBusinessProfilePicture,
    uploadBusinessDocument,
    fetchAdminUsers,
    fetchServicesClaimedByBusiness,
    createService,
    deleteService,
    updateService,
    uploadServiceImage,
    createTimeSlot,
    fetchTimeSlotsWithBookings,
    updateTimeSlot,
    deleteTimeSlot,
    updateBookingStatus,
    UpdateTimeSlotAvail,
    getTimeSlotAvailability,
    addReviewToProduct,
    fetchReviewsForProduct,
    signupLa,
    fetchLocalAuthorityUsers,
    fetchPendingLocalAuthorityUsers,
    approveLocalAuthorityUser,
    denyLocalAuthorityUser,
    fetchUpcomingBookings, 
    addFavoriteService,
    removeFavoriteService,
    addFavoriteProduct,
    removeFavoriteProduct,
    userInfo,
    fetchUserReportData,
    fetchBusinessReportData,
    fetchLocalAuthorityReportData,
    fetchUserBookings,
    fetchServicesByIds,
    fetchProductsByIds,
    fetchUserMessages,
    fetchServicesByBusiness,
    fetchBookingsForBusinessServices,
    fetchServicesByLocalAuthority,
    addReviewToService,
    fetchReviewsForService,
    deleteServiceReview,
    importServicesFromJson,
    fetchAdminUserBookings,
    deleteBlog,
    deleteBlogComment,
    deleteProductReview,
    uploadPDFFile,
    createPDF,
    fetchPDFs,
    updatePDF,
    deletePDF,
    manualUpdateItemsJson,
    getServiceImportStats
}


    return (
        <DBContext.Provider value={value}>
            {!loading && children }
        </DBContext.Provider>
    )
}